<template>
    <!-- recorrencia -->
    <v-dialog v-model="dialog" max-width="500px" max-height="100px" persistent>
      <v-form ref="form_dates_task">
        <v-card>
          <v-card-title>
            <span class="headline">Inclusão de Datas</span>
          </v-card-title>
            <v-container fluid grid-list-xs>
              <v-layout justify-space-between style="padding-bottom: 10px;">
                <v-flex grow>
                  <v-tooltip bottom>
                    <v-checkbox slot="activator" id="task_commitment" xs6 @change="(val) => {editedItem.begin = null}"
                      class="check-commitment" style="height: 20px; margin-top: 0px;" label="Compromisso" v-model="editedItem.commitment" :true-value="1" :false-value="0"></v-checkbox>
                    <span>Ao marcar esse campo essa tarefa será um compromisso com data inicio e previsão.</span>
                  </v-tooltip>
                </v-flex>
                <v-flex shrink v-if="editedItem.commitment === 1 && moment(editedItem.end).isValid() && moment(editedItem.begin).isValid()" style="padding-top: 8px; padding-bottom: 0px;">
                  <span v-if="editedItem.commitment === 1 && moment(editedItem.end).isValid() && moment(editedItem.begin).isValid()">{{'Duração de ' + moment.duration(moment(editedItem.end).diff(editedItem.begin)).format("h [hrs] m [min]")+'.'}}</span>
                </v-flex>
              </v-layout>

              <v-layout row align-baseline justify-start wrap>
                <v-flex v-if="editedItem.commitment === 1" xs12 sm6>
                  <!-- // @blur verifica se o valor antigo é diferente do atual, pois o componenete pdatetime faz muitas requisições de blur -->
                  <p-date-time id="task_date_begin" :label="translate('table.' + entity + '.field.begin')" :defaultHour="'00:00'" v-model="editedItem.begin" :rules="dateDiffRule().concat(requiredRule(translate('table.' + entity + '.field.begin'),190))"
                  ></p-date-time>
                </v-flex>
                <v-flex :class="editedItem.commitment === 1 ? 'xs12 sm6' : 'xs12'" >
                  <!-- // @blur verifica se o valor antigo é diferente do atual, pois o componenete pdatetime faz muitas requisições de blur -->
                  <p-date-time id="task_date_end" @keyup.native.ctrl.enter="view === 3 ? save(4) : saveEdit()"
                    :label="translate('table.' + entity + '.field.end')" :defaultHour="'23:59'" v-model="editedItem.end" :rules="editedItem.commitment === 1 ? dateDiffRule().concat(requiredRule(translate('table.' + entity + '.field.end'),190)) : dateDiffRule()"
                  ></p-date-time>
                </v-flex>
              </v-layout>
              <!-- <v-tooltip bottom>
                <v-checkbox slot="activator" id="task_commitment" xs6 @change="(val) => {editedItem.begin = null}"
                  class="check-commitment" style="padding-top: 15px;" label="Compromisso" v-model="editedItem.commitment" :true-value="1" :false-value="0"></v-checkbox>
                <span>Ao marcar esse campo essa tarefa será um compromisso com data inicio e previsão.</span>
              </v-tooltip>
              <span v-if="editedItem.commitment === 1 && moment(editedItem.end).isValid() && moment(editedItem.begin).isValid()" class="duration-commitment" style="padding-top: -35px;">{{'Duração de ' + moment.duration(moment(editedItem.end).diff(editedItem.begin)).format("h [hrs] m [min]")+'.'}}</span> -->
            </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#00acc2" dark text @click="confirm">Salvar</v-btn>
            <v-btn color="#00acc2" dark text @click="dialog = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
</template>
<script>
  import rules from './../../mixin/rules'
  import PDateTime from './../shared/PDateTime'
  export default{
    mixins: [rules],
    components: {PDateTime},
    data: () => ({
      entity: 'tasks',
      dialog: false,
      editedItem: {begin: null, end: null, commitment: 0}
    }),
    props: {
      task: {
        default: () => { return {} }
      }
    },
    methods: {
      openDates () {
        this.editedItem['begin'] = this.task['begin']
        this.editedItem['end'] = this.task['end']
        this.editedItem['commitment'] = this.task['commitment']
        this.dialog = true
      },
      confirm () {
        if (!this.$refs.form_dates_task.validate()) {
          this.$store.commit('snackbar/change_values', {text: 'Por favor, corrija as validações antes de salvar!', color: 'error', dialog: true})
          return false
        }
        this.dialog = false
        this.$emit('confirm', this.editedItem)
      }
    }
  }
</script>

<style scoped>
  .task-dates {
    position: relative;
  }
</style>


// WEBPACK FOOTER //
// src/components/shared/PTaskDates.vue